import React from 'react';
import style from '../message.module.scss';
import { Select, Icon } from 'antd';

type NextNodeProps = {
	nextNode: string;
	lock: boolean;
	onNodeSelect: (node: string) => void;
	elements: any[];
	nodeDetail: any;
};

export function NextNode(props: NextNodeProps) {
	const { nextNode, lock, onNodeSelect, elements, nodeDetail } = props;

	const nodes: any[] = [];
	elements.forEach((e: any) => {
		if (
			e.data &&
			e.data.type &&
			e.data.type !== 'start' &&
			e.data.type !== 'error' &&
			e.id !== nodeDetail.id
		) {
			nodes.push(e);
		}
	});

	return (
		<div className={style.nextNode}>
			<div className={style.label}>
				<label>Next Node</label>
			</div>
			<Select
				showSearch
				onChange={(e: any) => onNodeSelect(e)}
				suffixIcon={
					<Icon style={{ fontSize: '20px', margin: -5 }} type="caret-down" />
				}
				disabled={lock}
				value={nextNode || undefined}
				placeholder="Select the next node"
				optionLabelProp="label"
				style={{
					width: '100%',
					borderRadius: 8,
					color: '#000610',
					fontSize: 14,
				}}
				mode="default"
				size="large"
				filterOption={(input, option: any) => {
					return option && option.props
						? option.props.label
								.toString()
								.toLowerCase()
								.indexOf(input.toLowerCase()) >= 0
						: false;
				}}
			>
				{nodes &&
					nodes.map((el: any) => {
						return (
							<Select.Option
								key={el.id}
								value={el.id}
								label={
									(el &&
										el.data &&
										el.data.propertyDetails &&
										el.data.propertyDetails &&
										el.data.propertyDetails.name) ||
									el.id
								}
							>
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<div style={{ display: 'flex', flexDirection: 'row' }}>
										<img alt="icons" src={el.data.icon} />
										<p
											style={{
												height: el.data.type === 'end' ? 13 : '',
												width: el.data.type === 'end' ? 13 : '',
												marginLeft: '8px',
												marginTop: '12px',
												color: el.id === nextNode ? '#0F66C8' : '#000610',
											}}
										>
											{(el &&
												el.data &&
												el.data.propertyDetails &&
												el.data.propertyDetails &&
												el.data.propertyDetails.name) ||
												el.id}
										</p>
									</div>
									{el.id === nextNode && (
										<Icon type="check" style={{ color: '#0F66C8' }} />
									)}
								</div>
							</Select.Option>
						);
					})}
			</Select>
		</div>
	);
}
